import { LoadableAfterPaint } from '@confluence/loadable';

export const SpaceAnalyticsPageLoader = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-componentsSpaceAnalyticsPage" */ '../src/components/SpaceAnalytics/SpaceAnalyticsPage'
			)
		).SpaceAnalyticsPage,
});
